



 
// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/administration/piscine/edit/EditMns.vue'
import { getDefaultAloPiscine, AloPiscine } from '@/models/alo/AloPiscine'
import { toStringDictionary } from '@/utils/groupBy';
import { getImageUrl } from '@/utils/images';
import { AloMedia, getDefaultAloMedia } from '@/models/alo/AloMedia';
import cloneDeep from 'clone-deep';

@Component({
  name: 'ReadImage',    
   props: {
    piscine:{      
      default:getDefaultAloPiscine()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit}
})
export default class ReadImage extends Vue {
  private piscine!:AloPiscine
  private loading!:boolean 
  private saving = false

  get name(){
    return `photo piscine ${this.piscine.libelle}`
  }


  onImagesAdded(images:Array<AloMedia>) {
    //@ts-ignore
    const modified = cloneDeep(this.piscine) as AloPiscine
    modified.images = images
    this.saveData(modified,"Image(s) ajoutée(s)")
  }

  onImageDeleted(images:Array<AloMedia>){
    //@ts-ignore
    const modified = cloneDeep(this.piscine) as AloPiscine
    modified.images = images
    this.saveData(modified,"Image supprimée")
  }  

  onOrderChange(images:Array<AloMedia>) {
    const modified = cloneDeep(this.piscine) as AloPiscine
    modified.images = images
    this.saveData(modified,"Ordre des image(s) modifiée(s)")  
  }

  onImageUpdated(image:AloMedia) {
    
  }

  saveData(modified:AloPiscine,message:string = "") {        
    this.saving = true
    this.$store.myActions.ADM_PISCINE_SAVE_REQUEST(modified).then(() => {
      if(message.length>0 ) this.$store.myActions.UI_ADD_SNACK_MESSAGE(message)                  
    }).finally(()=>{      
      this.saving = false
    })        
  }

}
